import { lazy } from "react";

const Ticket = lazy(() => import("../Component/Ticket/Ticket"));
const Addticket = lazy(() => import("../Component/Ticket/Addticket"));
const Chat = lazy(() => import("../Component/Ticket/Chat"));

const ticketRoutes = [
  { path: "/manage-ticket", element: <Ticket />, protected: true },
  { path: "/add-ticket", element: <Addticket />, protected: true },
  { path: "/view-chat/:id", element: <Chat />, protected: true },
];

export default ticketRoutes;
